<div class="container">
    <div class="loader" *ngIf="isLoading">
        <nz-spin nzSimple [nzSize]="'large'" nzTip="Loading features..."></nz-spin>
    </div>
    @for (customerFeature of allFeatures; track $index){
        <customer-feature (updatedFeatures)="updateFeatures($event)" [customerFeature]="customerFeature" [customer]="customer" [vehicleFeature] = "vehicleFeature" [expertViewFeature]="expertViewFeature"></customer-feature>
    }
</div>
